import {
  axiosInstance as axios,
  axiosInstance2 as axiosV2,
} from "@/core/services/api.client";

const prefix = "api/v1/tenant/it";
const prefixV2 = "v2/tenant/it";

export default {
  updateClientTranslation: async (formData: any) =>
    (await axiosV2.put(prefixV2 + `/translations/client`, formData)).data,

  updateWebTranslation: async (formData: any) =>
    (await axiosV2.put(prefixV2 + `/translations/web`, formData)).data,

  uploadPublicFiles: async (formData: any) =>
    (await axiosV2.post(prefixV2 + "/upload-public", formData)).data,

  updateAndroidVersion: async (formData: {
    version?: string;
    url?: string;
    isForceUpdate?: boolean;
  }) => (await axiosV2.put(prefixV2 + "/android-update", formData)).data,
};
